import { render, staticRenderFns } from "./settingsCustomerIcon.vue?vue&type=template&id=4af3ce68&scoped=true"
import script from "./settingsCustomerIcon.vue?vue&type=script&lang=js"
export * from "./settingsCustomerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3ce68",
  null
  
)

export default component.exports